var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from '../../helpers/Api';
import Ota from './Ota';
var OtaStore = /** @class */ (function () {
    function OtaStore() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.set = function (data) {
            _this.data = data.map(function (value) { return new Ota(value); });
            _this.loaded = true;
            return _this.data;
        };
        this.setOptions = function (data) {
            _this.dataOptions = data;
            _this.loaded = true;
            return _this.dataOptions;
        };
        this.push = function (data) {
            _this.data.push(new Ota(data));
            return _this.data;
        };
        this.replace = function (data) {
            console.log('replace - data: ', data);
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === data.id; }), 1, data);
        };
        this.pull = function (value) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
    }
    OtaStore.prototype.create = function (data) {
        return api.post('otas', data).then(this.push);
    };
    OtaStore.prototype.disable = function (id, disabled) {
        return api.patch("otas/".concat(id), { disabled: disabled }).then(this.pull);
    };
    OtaStore.prototype.read = function (id) {
        var eager = '[]';
        if (id)
            return api.get("otas/".concat(id, "?eager=").concat(eager));
        return api.get("otas?eager=".concat(eager)).then(this.set);
    };
    OtaStore.prototype.update = function (id, data) {
        return api.put("otas/".concat(id), data)
            .then(this.replace);
    };
    OtaStore.prototype.readOptions = function (ota) {
        return api.get("".concat(ota.toLowerCase(), "/options")).then(this.setOptions);
    };
    __decorate([
        observable
    ], OtaStore.prototype, "data", void 0);
    __decorate([
        observable
    ], OtaStore.prototype, "dataOptions", void 0);
    __decorate([
        observable
    ], OtaStore.prototype, "loaded", void 0);
    __decorate([
        action
    ], OtaStore.prototype, "set", void 0);
    __decorate([
        action
    ], OtaStore.prototype, "setOptions", void 0);
    __decorate([
        action
    ], OtaStore.prototype, "push", void 0);
    __decorate([
        action
    ], OtaStore.prototype, "replace", void 0);
    __decorate([
        action
    ], OtaStore.prototype, "pull", void 0);
    return OtaStore;
}());
export default OtaStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Otas/OtaStore.ts
// module id = 730
// module chunks = 0